var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormItem',{staticClass:"pcb-size",attrs:{"label":"拼板后尺寸"}},[_vm._v(" "+_vm._s(_vm.pcbSize.length || 0)+" x "+_vm._s(_vm.pcbSize.width || 0)+" cm ")])}
var staticRenderFns = []

export { render, staticRenderFns }